import { render } from "./UiPagination.vue?vue&type=template&id=1727367e&ts=true"
import script from "./UiPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiPagination.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1727367e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1727367e', __exports__)) {
    api.reload('1727367e', __exports__)
  }
  
  module.hot.accept("./UiPagination.vue?vue&type=template&id=1727367e&ts=true", () => {
    api.rerender('1727367e', render)
  })

}


export default __exports__